/**
 * Pure date helpers for the Holiday Management module.
 */

/**
 * Number of year options in the filter — kept at 7 slots, matching the
 * previous implementation's array size. Past years are removed, so the list
 * starts at the current year and runs forward:
 * 2026 → 2026, 2027, 2028, 2029, 2030, 2031, 2032.
 */
export const HOLIDAY_YEAR_OPTIONS = 6;

/**
 * Builds the year filter options: current year first, then upcoming years.
 * Past years and an "All years" option are intentionally excluded.
 *
 * @param currentYear The current calendar year (injectable for testing).
 * @param count Total number of options, including the current year.
 */
export const getHolidayYears = (
  currentYear: number,
  count: number = HOLIDAY_YEAR_OPTIONS
): string[] =>
  Array.from({ length: Math.max(1, count) }, (_, index) =>
    String(currentYear + index)
  );
